import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';

import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';
import $ from "jquery";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import  "./../assets/css/custom.css"; 
const InvoicingCustomerBalanceDetails = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [paymentdata, setPaymentdata] = useState([]);
  const [invoicestatus, setInvoicestatus] = useState([]);
  const [value, setValue] = useState({});
  let { id } = useParams();
  const [permission, setPermission] = useState({});
    let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(211)); 
console.log(permission);

    axios
      .get(`/customers-balances/details/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          console.log(response.data.data);
          setData(response.data.data.invoices);
          setValue(response.data.data.customer);
          setPaymentdata(response.data.data.payments);
        setInvoicestatus(response.data.data.overview);
        }
      })
      .catch((error) => {
        toast.error(error);
      });

  
 

  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  // const deleteItem = (item) => {

 

    const statusOptions =[
 
      {
        "id": 1,
        "title": "PAID",
        "type": 2,
        "color": "white",
        "bg_color": "GREEN",
    },
    {
      "id": 2,
      "title": "OPEN",
      "type": 2,
      "color": "white",
      "bg_color": "BLUE",
  },
  {
      "id": 0,
      "title": "DUE",
      "type": 2,
      "color": "white",
      "bg_color": "RED",
  },
    ];
    
  
      const changeOrderStatus = (user_id, status,type) =>{

      Swal.fire({
        title: 'Do you want change Status?',
        //text: 'This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'green',
        cancelButtonColor: '#d33',
        confirmButtonText: 'CONFIRM',
        customClass: "swal-orders"
      }).then((result) => {
        if (result.isConfirmed) {
      let season_id = localStorage.getItem("season_id");

          axios.get(`/invoice/change-status/${season_id+'_'+user_id}/${status}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
              .then((response) => {
                console.log(response);
                if (response.data.code === 200) {
                  $("#status-"+type+"-"+user_id).text(response.data.data.order_status.title);
                  $("#status-"+type+"-"+user_id).css('background-color',response.data.data.order_status.bg_color);
                  $("#status-"+type+"-"+user_id).css('color',response.data.data.order_status.color);
                        let season_id = localStorage.getItem("season_id");

                  axios
                  .get(`/customers-balances/details/${season_id+'-'+id}`, {
                    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                  })
                  .then((response) => {
                    if (response.data.code === 200) {
                      console.log(response.data.data);
                      setData(response.data.data.invoices);
                      setValue(response.data.data.customer);
                      setPaymentdata(response.data.data.payments);
                      setInvoicestatus(response.data.data.overview);
                    }
                  })
                  .catch((error) => {
                    toast.error(error);
                  });

                  Swal.fire(
                    'Success!',
                    'Invoice Status has been changed Successfully.',
                    'success'
                  );
                
                }
              })
              .catch((error) => {
                console.log(error);
              }); 
             }
      });
    }
  const OrderStatusDropdownCell = ({ row, permission, statusOptions, changeOrderStatus }) => {
      if (permission && permission.update == 1) {
        return (
          <div className="btn-group custom-table-btn-group">
            <button
              type="button"
              className="btn btn-block dropdown-toggle me-1"
              id={`status-all-${row.original.id}`}
              style={{ backgroundColor: row.original.invoicing_status?.bg_color, color: row.original.invoicing_status?.color }}
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {row.original.invoicing_status?.title || ''}
            </button>
            <div className="dropdown-menu">
              {statusOptions &&
                statusOptions.map((shipp) => (
                  <button
                    key={shipp.id}
                    className="dropdown-item btn btn-block"
                    style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
                    onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
                  >
                    {shipp.title}
                  </button>
                ))}
            </div>
          </div>
        );
      }
  
  
    return (
      <button
        type="button"
        className="btn btn-block me-1"
        id={`status-all-${row.original.id}`}
        style={{ backgroundColor: row.original.invoicing_status?.bg_color, color: row.original.invoicing_status?.color }}
      >
        {row.original.invoicing_status?.title || ''}
      </button>
    );
  };
  OrderStatusDropdownCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        invoicing_status: PropTypes.shape({
          title: PropTypes.string,
          bg_color: PropTypes.string,
          color: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
    permission: PropTypes.shape({
      update: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    statusOptions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
        bg_color: PropTypes.string,
        color: PropTypes.string,
      })
    ).isRequired,
    changeOrderStatus: PropTypes.func.isRequired,
  };
  

// ✅ Invoice Link Cell Component
const InvoiceLinkCell = ({ row }) => {
  const url = `/invoices-payment/${row.original.id}`;
  return <a href={url}>{row.original.invoice_number}</a>;
};

// ✅ PropTypes Validation
InvoiceLinkCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.any.isRequired,
      invoice_number: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

  const columns =
  [
    // {
    //   accessorKey: 'invoice_number', //normal accessorKey
    //   header: 'Invoice Number',
    // },
     {
      header: 'Invoice Number',
      accessorFn: (row) => row.invoice_number,
      Cell: InvoiceLinkCell,
    },

    {
      header: 'Invoice Status',
      accessorFn: (row) => row.invoicing_status?.title || '',
      Cell: (props) => (
        <OrderStatusDropdownCell
          {...props}
          permission={permission}
          statusOptions={statusOptions}
          changeOrderStatus={changeOrderStatus}
        />
      ),
    },
    {
      accessorKey: 'po_order_number', //normal accessorKey
      header: 'PO Order Number',
    },
    {
      accessorKey: 'date', //normal accessorKey
      header: 'Date',
    },
    {
      header: 'Customer',
      accessorFn: (row) => `${(row.customer_detail)?row.customer_detail.company_name:""} `,
    },
  
    {
      header: 'Total Sales',
      accessorFn: (row) => `${row.total_amount.toFixed(2)}`,
    },
    {
      header: 'Total Paid',
      accessorFn: (row) => `${row.paid.toFixed(2)}`,
    },
    {
      header: 'Credit Balance',
      accessorFn: (row) => `${(row.total_amount - row.paid - row.total_credit_note).toFixed(2)}`,
    }, 
    {
      header: 'Credit Note',
      accessorFn: (row) => `${row.total_credit_note.toFixed(2)}`,
    },
     
   ];


   
  const payments_columns =
  [
    {
      accessorKey: 'opearation_type',
      header: 'Operation Type',
    },
    {
      accessorKey: 'payment_date', //normal accessorKey
      header: 'Payment Date',
    },
    {
      // accessorKey: 'payment_amount', //normal accessorKey
       accessorFn: (row) => `${row.payment_amount.toFixed(2)}`,
      header: 'Payment Amount',
    },
    {
      accessorKey: 'exchange_date', //normal accessorKey
      header: 'Exchange Date',
    },
    {
      // accessorKey: 'exchange_rate', //normal accessorKey
       accessorFn: (row) => `${row.exchange_rate.toFixed(2)}`,
      header: 'Exchange Rate',
    },
   
   
    {
      header: 'Amount',
      accessorFn: (row) => `${row.amount.toFixed(2)}` +`${" MAD"} `,
    },
  
   ];
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Customers Balance Details</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customer-balances">Customers Balances</Link>
                    </li>
                    <li className="breadcrumb-item active">Customers Balance Details</li>
                  </ul>
                </div>
                <div className="col-auto">
                  <Link to={`/customer-balances-details-customerdasboard/${id}`} className="btn btn-primary me-1">
                  
                    Customer Dashboard
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
              <div className="card customer-details-group">
                <div className="card-body">
                  <div className="row align-items-center">
                    
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-mail">
                          </i></span>
                          <div className="customer-details-cont">
                            <h6>Email Address</h6>
                            <p>{value.company_email}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-phone"></i></span>
                          <div className="customer-details-cont">
                            <h6>Phone Number</h6>
                            <p>{value.company_phone}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-airplay"></i></span>
                          <div className="customer-details-cont">
                            <h6>Company Name</h6>
                            <p>{value.company_name}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-globe"></i></span>
                          <div className="customer-details-cont">
                            <h6>Website</h6>
                            <p>{value.company_website}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                   
                  </div>
                </div>
              </div>
              </div>
            </div>

            <div className="row">
                {/* {invoicestatus && invoicestatus.map((item) => (
                        <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count">
                                  <div className="dash-title"> {item.status_title_name}</div>
                                  <div className="dash-counts">
                                    <p>{(item.stats_detail.amount  != null) ? item.stats_detail.amount.toFixed(2) : "0.00"}{value.currency.symbol} </p>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                      ))} */}
                       <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count">
                                  <div className="dash-title"> Credit Balance</div>
                                  <div className="dash-counts">
                                    <p>{invoicestatus?.credit_balance != null ? Number(invoicestatus.credit_balance).toFixed(2) : '0.00'}</p>

                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                       <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count">
                                  <div className="dash-title"> Total Sales</div>
                                  <div className="dash-counts">
                                    <p>{invoicestatus?.total_sale != null ? Number(invoicestatus.total_sale).toFixed(2) : '0.00'}</p>

                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                       <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count">
                                  <div className="dash-title"> Total Paid</div>
                                  <div className="dash-counts">
                                    <p>{invoicestatus?.total_paid != null ? Number(invoicestatus.total_paid).toFixed(2) : '0.00'}</p>
                                   </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>rt
                       {/* <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count">
                                  <div className="dash-title"> Total Credit Note</div>
                                  <div className="dash-counts">
                                    <p>{invoicestatus?.credit_note != null ? Number(invoicestatus.credit_note).toFixed(2) : '0.00'}</p>
                                   </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div> */}
              </div>
              
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card card-table">
                    {/* <div className="card-header"> <h3>INVOICES</h3></div> */}
                    <div className="card-body">
                         {permission && permission.list == 1 && ( 
                            
                                    <div className="card-body">
                                            <ul className="nav nav-tabs nav-tabs-bottom">
                                            
                                          
                                            <li className="nav-item">
                                                <a className="nav-link active" href="#listing-groupby-supplier" data-bs-toggle="tab">Invoices</a>                                  
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> Payments</a>                                   
                                            </li>                    
                                            </ul>
                                            <div className="tab-content">
                                          
                                            <div className="tab-pane show active" id="listing-groupby-supplier">
                                            <div className="row"   id="listing-followup">
                                              <div className="col-sm-12">
                                                <div className="card card-table">
                                                  <div className="card-body">
                                                      <div className="table-responsive">
                      
                                                      <MaterialReactTable columns={columns} data={data} 
                                                          enableColumnOrdering
                                                        />
                                                      </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                              
                                              </div>                                
                                              <div className="tab-pane  " id="listing-all">
                                            <div className="row"   id="listing-followup">
                                              <div className="col-sm-12">
                                                <div className="card card-table">
                                                  <div className="card-body">
                                                      <div className="table-responsive">
                                                      <MaterialReactTable columns={payments_columns} data={paymentdata} 
                                                          enableColumnOrdering
                                                        />
                                                      
                                                      </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                              
                                              </div>                                
                                            
                                            </div>                             
                                        </div>
                               )}
                   
                       
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default InvoicingCustomerBalanceDetails;
